import { videoAttributes } from 'features/landing/components/Video';

export const getCDNVideoLink = (attributes: videoAttributes) => {
  return attributes.type === 'asset' && attributes.cdnPath ? attributes.cdnPath : attributes.path;
};
